const NAV_GROUPS = [
  {
    title: "About",
    items: [
      { href: "#mission", label: "Mission" },
      { href: "#vedas", label: "The Vedas" },
      { href: "#practice", label: "Practice" },
      { href: "#house", label: "House of Unity" },
    ],
  },
  {
    title: "Learning",
    items: [
      { href: "/register", label: "Courses & classes" },
      { href: "/calendar", label: "Calendar" },
      { href: "/youtube", label: "Library" },
      { href: "/register", label: "Join the community" },
    ],
  },
  {
    title: "Account",
    items: [
      { href: "/login", label: "Sign in" },
      { href: "/register", label: "Create an account" },
    ],
  },
] as const;

export function Footer() {
  return (
    <footer className="bg-[var(--color-vellum-warm)] border-t border-[var(--color-rule-strong)] relative overflow-hidden">
      <div className="container-edit pt-24 pb-12">
        <div className="grid grid-cols-12 gap-y-16 gap-x-8">
          {/* Brand column */}
          <div className="col-span-12 lg:col-span-5">
            <div className="flex items-center gap-3 mb-8">
              <img src="/logo-mark.svg" alt="" className="h-10 w-10" />
              <span className="font-display text-[1.6rem] tracking-tight leading-none">
                Veda <span className="font-display-italic">Union</span>
              </span>
            </div>
            <p className="font-display-italic text-[1.45rem] leading-snug max-w-md">
              Unity. Purity. Divinity. — a network for those who chant the Vedas.
              Since 2010.
            </p>

            <div className="flex items-center flex-wrap gap-x-2 gap-y-1 mt-10 -mx-3">
              {[
                { href: "https://www.facebook.com/vedaunion", label: "Facebook", external: true },
                { href: "https://youtube.com/@vedaunion", label: "YouTube", external: true },
                { href: "https://www.instagram.com/vedaunion/", label: "Instagram", external: true },
                { href: "mailto:info@vedaunion.org", label: "Email", external: false },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target={s.external ? "_blank" : undefined}
                  rel={s.external ? "noopener noreferrer" : undefined}
                  className="font-grotesk text-[0.78rem] tracking-[0.16em] uppercase text-[var(--color-ink-mute)] hover:text-[var(--color-violet)] transition-colors px-3 py-2 -my-1"
                >
                  {s.label}
                </a>
              ))}
            </div>
          </div>

          {/* Nav columns */}
          {NAV_GROUPS.map((g) => (
            <nav
              key={g.title}
              className="col-span-6 sm:col-span-4 lg:col-span-2 lg:col-start-auto"
              aria-label={g.title}
            >
              <h4 className="font-grotesk text-[0.7rem] tracking-[0.22em] uppercase text-[var(--color-violet)] mb-6">
                {g.title}
              </h4>
              <ul className="flex flex-col gap-3">
                {g.items.map((it) => (
                  <li key={it.href + it.label}>
                    <a
                      href={it.href}
                      className="font-display text-[1.15rem] leading-snug text-[var(--color-ink)] hover:text-[var(--color-violet)] transition-colors"
                    >
                      {it.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          {/* Contact */}
          <div className="col-span-12 sm:col-span-8 lg:col-span-3">
            <h4 className="font-grotesk text-[0.7rem] tracking-[0.22em] uppercase text-[var(--color-violet)] mb-6">
              Contact
            </h4>
            <address className="not-italic font-display text-[1.15rem] leading-relaxed">
              Krnjak,
              <br />
              Croatia
              <br />
              <a
                href="mailto:info@vedaunion.org"
                className="hover:text-[var(--color-violet)] transition-colors"
              >
                info@vedaunion.org
              </a>
            </address>
          </div>
        </div>

        <hr className="rule mt-20 mb-8" />

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-grotesk text-[0.75rem] tracking-[0.08em] text-[var(--color-ink-mute)]">
          <p>
            &copy; {new Date().getFullYear()} Veda Union. All rights reserved.
          </p>
          <p>
            Founded by{" "}
            <span className="font-display-italic text-[0.95rem]">Vojko Kercan</span> &amp;{" "}
            <span className="font-display-italic text-[0.95rem]">Branimir Gonan</span>.
          </p>
        </div>
      </div>
    </footer>
  );
}
